export default __webpack_public_path__ + "static/media/edit-colorized.ac86b71c.svg";